import {Project} from "../models/project";


export class ProjectMunicipalityFilter {

    /**
     * Apply municipality filters
     * @param projects
     * @param filters
     */
    static apply(projects: Project[], filters: string[]): Project[] {
        if (!filters || filters.length === 0) {
            return projects;
        }
        // check if process filters included
        if (!filters.some((f) => f.includes("municipality-"))) {
            // no municipality filters
            return projects;
        }

        return projects.filter((p: Project) => {
            if (!p || !p.municipalities || p.municipalities.length === 0) {
                // do not return projects without municipality when filtering for municipality
                return false;
            }

            const keys = p.municipalities.map((m) => `municipality-${m.bfsNr}`);
            // show activity when filter key matches
            return filters.some((f) => keys.includes(f));
        });
    }
}
